<template>
  <div class="content Tabs">

    <b-tabs card v-model="tabIndex">
      <b-tab v-if="currentUser.role != 'Reader'" :title="lang.tab_Tasks" :title-link-class="textColors"
        :title-item-class="textColors" :active="tabIndex == 0">

        <ProjectTasksComponent :lang="lang.Tasks" parent="details"></ProjectTasksComponent>


      </b-tab>
      <!-- <b-tab :title="lang.tab_Included" :title-link-class="textColors" :title-item-class="textColors">
      
        <WhatIsIncludedComponent :lang="lang.WhatIsIncluded" parent="details"></WhatIsIncludedComponent>
      </b-tab> -->
      <b-tab v-if="appConf.status.isBasicBundle == false" :title="lang.tab_Report" :title-link-class="textColors"
        :title-item-class="textColors" :active="tabIndex == 1">

        <ProjectChangeReportComponent :lang="lang.ProjectReport" parent="details"></ProjectChangeReportComponent>
      </b-tab>
      <b-tab v-if="appConf.status.isBasicBundle == false" :title="lang.tab_FileComparison"
        :title-link-class="textColors" :title-item-class="textColors" :active="tabIndex == 2">

        <FileComparisonComponent :lang="lang.FileComparison"></FileComparisonComponent>
      </b-tab>
      <b-tab v-if="appConf.status.isBasicBundle == false" :title="lang.tab_Delegations" :title-link-class="textColors"
        :title-item-class="textColors" :active="tabIndex == 3">

        <DelegationsReportComponent :lang="lang.Delegations"></DelegationsReportComponent>
      </b-tab>
      <b-tab v-if="appConf.status.isBasicBundle == false" :title="lang.tab_IPCImage" :title-link-class="textColors"
        :title-item-class="textColors" :active="tabIndex == 4">

        <IpcViewerComponent name="CompareVariants" :lang="lang.IPCViewer" :zooming="true"></IpcViewerComponent>

      </b-tab>


    </b-tabs>

  </div>

</template>
<script>
import { mapGetters } from 'vuex'
import ProjectTasksComponent from '@/components/shared/ProjectTasksComponent'
import WhereUseTableComponent from '@/components/shared/WhereUseTableComponent'
import ProjectChangeReportComponent from '@/components/shared/ProjectChangeReportComponent'
import FileComparisonComponent from '@/components/shared/FileComparisonComponent'
import DelegationsReportComponent from '@/components/shared/DelegationsReportComponent'
import IpcViewerComponent from '@/components/shared/IpcViewerComponent'

// import CompareLibrariesComponent from '@/components/shared/CompareLibrariesComponent'
// import WhereLibUsedComponent from '@/components/shared/WhereLibUsedComponent'
//import WhatIsIncludedComponent from '@/components/shared/WhatIsIncludedComponent'


export default {
  name: "Content",
  components: {
    ProjectTasksComponent,
    WhereUseTableComponent,
    ProjectChangeReportComponent,
    FileComparisonComponent,
    DelegationsReportComponent,
    IpcViewerComponent
    
    // CompareLibrariesComponent,
    // WhereLibUsedComponent,
    //WhatIsIncludedComponent
   

  },
  props:{
    lang: Object
  },
  data () {
    return {
      tabIndex: 0
      
    }
  },
  computed: {
    ...mapGetters({
      selectedRows: 'selectedRows',
      appConf: 'appConf',
      currentUser: 'currentUser'
    }),
    
    isAlternativeSelected(){
      return this.$store.getters.selectedAlternative.distributorPartId != undefined;
    },
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    },
    
  },
  created() {
    this.getTabIndex();


  },
  watch: {
    tabIndex: function (newVal) {

      let obj = {};
      obj[this.$route.path + "__right"] = newVal;

      this.$store.commit("SETTABDATA", obj);

      //####################
    }
  },
  methods: {
    getTabIndex() {
      

      if (this.$store.getters.tabData[this.$route.path + "__right"] != undefined) {
        this.tabIndex = this.$store.getters.tabData[this.$route.path + "__right"];
      } else {
        this.tabIndex = 0;
      }

    },
  },
}
</script>

<style scooped>

</style>



// WEBPACK FOOTER //
// src/components/ProjectManager/Views/ProjectDetails/Right/Content/Content.vue